import { ValueOf } from '../utilities/types';

const creditRiskOperators = {
  NUMERICAL_LESS_THAN: 'numerical-less-than',
  NUMERICAL_STRICTLY_LESS_THAN: 'numerical-strictly-less-than',
  NUMERICAL_GREATER_THAN: 'numerical-greater-than',
  NUMERICAL_STRICTLY_GREATER_THAN: 'numerical-strictly-greater-than',
} as const;

export type CreditRiskOperators = ValueOf<typeof creditRiskOperators>;

const creditRiskOperatorChoices = [
  { id: creditRiskOperators.NUMERICAL_GREATER_THAN, name: 'Greater Than' },
  { id: creditRiskOperators.NUMERICAL_STRICTLY_GREATER_THAN, name: 'Strictly Greater Than' },
  { id: creditRiskOperators.NUMERICAL_LESS_THAN, name: 'Less Than' },
  { id: creditRiskOperators.NUMERICAL_STRICTLY_LESS_THAN, name: 'Strictly Less Than' },
];

export default creditRiskOperatorChoices;
